<template>
  <table role="presentation" cellpadding="0" cellspacing="0" border="0" style="border-collapse: collapse;" :style="{ 'font-family': data.font }">
    <tbody>
      <tr>
        <td align="left" style="padding: 0;">
          <div style="display: flex; flex-direction: column; font-style: normal; line-height: 1.5;">
            <div>
              <span
                v-if="data.displayName"
                style="font-weight: 600;"
                :style="{ fontSize: useFontSizeScale(16).value }"
              >
                {{ data.displayName }}
              </span>
              <br>
              <span
                v-if="data.profession"
                style="font-weight: 500;"
                :style="{ fontSize: useFontSizeScale(12).value }"
              >
                {{ data.profession }}
              </span>
            </div>

            <div
              v-if="data.company"
              style="margin-top: 12px; font-weight: 700;"
              :style="{ fontSize: useFontSizeScale(13).value }"
            >
              {{ data.company }}
            </div>

            <div
              v-if="data.address"
              style="border-radius: 12px; font-weight: 400;"
              :style="{ fontSize: useFontSizeScale(12).value }"
            >
              {{ data.address }}
            </div>

            <span
              style="border-radius: 12px; font-weight: 400;"
              :style="{ fontSize: useFontSizeScale(12).value }"
            >
              <a v-if="data.email" :href="'mailto:' + data.email" style="color: inherit; text-decoration: none;">{{ data.email }}</a>
              <span v-if="data.email && data.telephoneNumber">, </span>
              <a v-if="data.telephoneNumber" :href="'tel:' + data.telephoneNumber" style="color: inherit; text-decoration: none;">{{ data.telephoneNumber }}</a>
            </span>
          </div>
        </td>
      </tr>

      <tr>
        <td align="left" style="padding: 0;">
          <table role="presentation" cellpadding="0" cellspacing="0" border="0" style="width: 100%; display: flex; gap: 12px; margin-top: 12px;">
            <tbody>
              <tr>
                <td v-if="data.instagram && data.instagramIconUrl" style="text-align: center; padding-right: 12px;">
                  <a
                    tabindex="-1"
                    :href="'https://www.instagram.com/' + data.instagram"
                    style="display: inline-block; text-decoration: none; width: 16px; height: 16px;"
                    target="_blank"
                  >
                    <img
                      :src="data.instagramIconUrl"
                      alt="Instagram"
                      width="16"
                      height="16"
                      style="display:inline-block;"
                      target="_blank"
                    />
                  </a>
                </td>
                <td v-if="data.facebook && data.facebookIconUrl" style="text-align: center; padding-right: 12px;">
                  <a
                    tabindex="-1"
                    :href="'https://www.facebook.com/' + data.facebook"
                    style="display: inline-block; text-decoration: none; width: 16px; height: 16px;"
                    target="_blank"
                  >
                    <img
                      :src="data.facebookIconUrl"
                      alt="Facebook"
                      width="16"
                      height="16"
                      style="display:inline-block;"
                    />
                  </a>
                </td>
                <td v-if="data.linkedin && data.linkedinIconUrl" style="text-align: center; padding-right: 12px;">
                  <a
                    tabindex="-1"
                    :href="'https://www.linkedin.com/in/' + data.linkedin"
                    style="display: inline-block; text-decoration: none; width: 16px; height: 16px;"
                    target="_blank"
                  >
                    <img
                      :src="data.linkedinIconUrl"
                      alt="LinkedIn"
                      width="16"
                      height="16"
                      style="display:inline-block;"
                    />
                  </a>
                </td>
                <td v-if="data.youtube && data.youtubeIconUrl" style="text-align: center; padding-right: 12px;">
                  <a
                    tabindex="-1"
                    :href="'https://www.youtube.com/@' + data.youtube"
                    style="display: inline-block; text-decoration: none; width: 16px; height: 16px;"
                    target="_blank"
                  >
                    <img
                      :src="data.youtubeIconUrl"
                      alt="YouTube"
                      width="16"
                      height="16"
                      style="display:inline-block;"
                    />
                  </a>
                </td>
                <td v-if="data.x && data.xIconUrl" style="text-align: center; padding-right: 12px;">
                  <a
                    tabindex="-1"
                    :href="'https://www.x.com/' + data.x"
                    style="display: inline-block; text-decoration: none; width: 16px; height: 16px;"
                    target="_blank"
                  >
                    <img
                      :src="data.xIconUrl"
                      alt="X (Twitter)"
                      width="16"
                      height="16"
                      style="display:inline-block;"
                    />
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>

      <tr v-if="data.imageUrl">
        <td align="left" style="padding: 0;">
          <div style="text-align: left; margin-top: 24px;">
            <img
              :src="data.imageUrl"
              alt=""
              style="display: inline-block; max-width: 338px; max-height: 120px; border-radius: 16px;"
            />
          </div>
        </td>
      </tr>

    </tbody>
  </table>
</template>

<script setup>
import { useFontSizeScale } from '@/io.ox/mail/settings/signatures/signature-designer/composables/useFontSizeScale'

const availableFields = [
  'address',
  'displayName',
  'profession',
  'company',
  'telephoneNumber',
  'email',
  'facebook',
  'instagram',
  'youtube',
  'linkedin',
  'x',
  'imageUrl',
  'font',
  'fontSize'
]

defineProps({
  data: { type: Object, required: true }
})

defineExpose({
  availableFields,
  imageSlots: [
    { field: 'imageUrl', aspect: 'banner' }
  ],
  previewTheme: { text: 'black' }
})
</script>
